import { render, staticRenderFns } from "./PersonaCbusView.vue?vue&type=template&id=18c398a0&scoped=true"
import script from "./PersonaCbusView.vue?vue&type=script&lang=js"
export * from "./PersonaCbusView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c398a0",
  null
  
)

export default component.exports